import React from 'react'
import {graphql} from 'gatsby'
import Container from '../components/container'
import GraphQLErrorList from '../components/graphql-error-list'
import SEO from '../components/seo'
import Layout from '../containers/layout'
import Contributor from '../components/Contributor/contributor'
import ProjectPreviewGrid from '../components/project-preview-grid'
import {mapEdgesToNodes, filterOutDocsWithoutSlugs} from '../lib/helpers'

export const query = graphql`
  query ProfileTemplateQuery($id: String!) {
    profile: sanityPerson(id: {eq: $id}) {
      name
      _rawBio
      roles
      title
      _rawImage
      slug {
        current
      }
    }
    articles: allSanityArticle(
      filter: {
        authors: {elemMatch: {person: {id: {eq: $id}}}}
        slug: {current: {ne: null}}
        publishedAt: {ne: null}
      }
      sort: {fields: [publishedAt], order: DESC}
    ) {
      edges {
        node {
          id
          mainImage {
            asset {
              _id
            }
            alt
          }
          title
          _rawExcerpt
          slug {
            current
          }
        }
      }
    }
  }
`

const ProfileTemplate = props => {
  const {data, errors} = props
  const profile = data && data.profile
  const articleNodes =
    data && data.articles && mapEdgesToNodes(data.articles).filter(filterOutDocsWithoutSlugs)
  return (
    <Layout>
      {errors && <SEO title='GraphQL Error' />}
      {profile && <SEO title={profile.name} />}
      {errors && (
        <Container>
          <GraphQLErrorList errors={errors} />
        </Container>
      )}
      {profile && (
        <Container>
          <Contributor
            name={profile.name}
            bio={profile._rawBio}
            roles={profile.roles}
            image={profile._rawImage}
            slug={profile.slug && profile.slug.current}
            title={profile.title}
          />
          {articleNodes && articleNodes.length > 0 && (
            <ProjectPreviewGrid nodes={articleNodes} title={`Artikler av ${profile.name}`} />
          )}
        </Container>
      )}
    </Layout>
  )
}

export default ProfileTemplate
